import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Info from "./InfoPopup";
import Filter from "./Filter";
import Search from "./Search";

import { ReactComponent as TravelExplore } from "../icons/travel_explore.svg";

import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  appBar: {
    zIndex: 1301,
    height: "66px",
    position: "relative",
    padding: "0px 15px",
  },
  tooltip: {
    backgroundColor: "white",
    color: "#00568E",
    fontSize: "9pt",
    border: "1px solid #00568E",
  },
});

class Navbar extends Component {
  openGeschichtsportal = () => {
    if (!this.props.progressMap) {
      window.open(
        `https://geoportal.kreis-herford.de/geschichtsportal/?x=${this.props.coordinates.latitude}&y=${this.props.coordinates.longitude}&zoom=${this.props.zoom}&split=true&links=2017&rechts=1895`
      );
    } else {
      window.open(
        "https://geoportal.kreis-herford.de/geschichtsportal/?x=52.16320377183103&y=8.665241685225958&split=true&links=2017&rechts=1895"
      );
    }
  };

  render() {
    return (
      <AppBar position="static" className={this.props.classes.appBar}>
        <Toolbar style={{ padding: 0, height: "inherit" }} id="topAnchor">
          <Tooltip
            title="Geoportal Kreis Herford"
            classes={{
              tooltip: this.props.classes.tooltip,
            }}
          >
            <a
              href="https://geoportal.kreis-herford.de#geschichte"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/icon_kreishf_signet.svg`}
                height="40"
                width="auto"
                className="d-inline-block align-top"
                style={{ display: "flex" }}
              />
            </a>
          </Tooltip>
          <div
            style={{
              color: "white",
              fontWeight: "bold",
              flexGrow: 1,
              marginLeft: "10px",
            }}
          >
            Mühlen im Kreis Herford
          </div>
          <Search />
          <Filter />
          <Tooltip
            title="Geschichtsportal öffnen"
            classes={{
              tooltip: this.props.classes.tooltip,
            }}
          >
            <IconButton
              color="inherit"
              onClick={this.openGeschichtsportal}
              style={{ padding: 0, marginRight: "15px" }}
              className="history-button"
            >
              <TravelExplore />
            </IconButton>
          </Tooltip>
          <Info information={false} />
        </Toolbar>
      </AppBar>
    );
  }
}

Navbar.propTypes = {
  mills: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  progress: PropTypes.bool.isRequired,
  coordinates: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  progressMap: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  mills: state.mill.mills,
  selected: state.mill.selected,
  progress: state.mill.progress,
  coordinates: state.settings.coordinates,
  zoom: state.settings.zoom,
  progressMap: state.mill.progressMap,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles, { withTheme: true })(Navbar));
